import React from 'react'
import { CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import useStyles from './styles'

type SearchProps = {
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
  search: CallableFunction
}

const Search: React.FC<SearchProps> = ({ value, setValue, search }) => {
  const theme = useTheme()

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <input
        value={value}
        onChange={e => {
          const value = e.target.value
          setValue(value)
          search(value)
        }}
        placeholder='Search or start new chat'
        className={classes.input}
      />

      {value.trim().length > 0 && (
        <div onClick={() => setValue('')} className={classes.cancel}>
          <CloseCircle size={theme.size.base} />
        </div>
      )}
    </div>
  )
}

export default Search
